var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceBarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3v18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8v7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5v13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceBarsIcon);
export default __webpack_public_path__ + "static/media/voice-bars-icon.18211ddef5772652959342acee5d1bf1.svg";
export { ForwardRef as ReactComponent };